import { gql } from '@apollo/client';
import type { InhubTransportRoutePageInput } from '../queries/getInhubTransportRouteSummariesPage';

export const GENERATE_INHUB_TRANSPORT_ROUTE_SUMMARIES_EXPORT = gql`
  mutation GenerateInhubTransportRouteSummariesExport(
    $filter: InhubTransportRoutePageInput!
    $timezone: String
  ) {
    generateInhubTransportRouteSummariesExport(filter: $filter, timezone: $timezone)
  }
`;

export interface GenerateInhubTransportRouteSummariesExportVariables {
    filter: InhubTransportRoutePageInput;
    timezone?: string;
}

export interface GenerateInhubTransportRouteSummariesExportResponse {
    generateInhubTransportRouteSummariesExport: string;
}
